<template>
    <b-modal
        id="edit-record-modal"
        v-model="modal"
        v-if="record"
        modal-class="apprentice-default-modal"
        size="md"
        :title="`${$t('slu_dashboard.edit_student')}: ${record.full_name}`"
        :ok-title="$t('common.save')"
        ok-variant="primary"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        @ok="ok">
        <div class="edit-module-record">
            <!--            <b-form-group class="student-tag-select-group"-->
            <!--                          label="Status"-->
            <!--                          label-for="student-module-status-select">-->
            <!--                <design-2021-apprentice-multiselect-component id="student-module-status-select" -->
            <!--                                                              class="student-module-status-select" -->
            <!--                                                              :options="statusOptions" -->
            <!--                                                              label="name" -->
            <!--                                                              :show-labels="false" -->
            <!--                                                              v-model="record.status" -->
            <!--                                                              :multiple-select="false" -->
            <!--                                                              track-by="id" -->
            <!--                                                              :disabled="true">-->

            <!--                <template slot="singleLabel" slot-scope="props">-->
            <!--                    <div class="selected-option">-->
            <!--                        <span class="tag-color" :style="{backgroundColor: `${props.option.color}` }"></span>-->
            <!--                        <div class="tag-name">{{ props.option.name }}</div>-->
            <!--                    </div>-->
            <!--                </template>-->

            <!--                <template slot="option" slot-scope="props">-->
            <!--                    <div class="tag-option">-->
            <!--                        <span class="tag-color" :style="{backgroundColor: `${props.option.color}` }"></span>-->
            <!--                        <div class="tag-name">{{ props.option.name }}</div>-->
            <!--                    </div>-->
            <!--                </template>-->
            <!--            </design-2021-apprentice-multiselect-component>-->
            <!--            </b-form-group>-->

            <b-form-group
                class="student-module-feedback"
                label="Feedback"
                label-for="student-module-status-select">
                <b-form-textarea
                    class="apprentice-textarea with-border"
                    v-model="record.feedback"
                    rows="3"
                    max-rows="3"
                    :placeholder="$t('slu_dashboard.fill_feedback_in')">
                </b-form-textarea>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-slu-dashboard-module-edit-record-modal-component',
    props: {
        statusOptions: {
            type: Array,
            required: true,
        },
        sluModuleIn: {
            type: Object,
            required: true,
        },
        sluCourseIn: {
            type: Object,
            required: true,
        },
        sluCohortIn: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            modal: false,
            record: null,
        };
    },

    methods: {
        show(record) {
            this.record = record;
            this.modal = true;
        },

        ok() {
            this.$emit('record-update', this.record);
            let data = {
                userId: this.record.id,
                moduleId: this.sluModuleIn.id,
                cohortId: this.sluCohortIn.id,
                courseId: this.sluCourseIn.id,
                feedback: this.record.feedback,
            };
            if (this.record.status.id === null) {
                data.completed = false;
            } else if (this.record.status.id === 0) {
                data.completed = true;
            } else {
                data.completed = this.record.status.finished;
                data.statusTagId = this.record.status.id;
            }

            this.alert.saving();
            axios.post(this.routes.sluModuleRecord(), data).then(
                (response) => {
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.selected-option,
.tag-option {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    column-gap: 8px;

    .tag-color {
        display: inline-block;
        width: 15px;
        height: 15px;
        border-radius: 50%;
    }
}

.edit-module-record {
    .student-tag-select-group {
        margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
    }
}
</style>
